export const wrapperIdentifier = 'chat';
